export default __webpack_public_path__ + "static/media/Bottom.562a4a78.jpg";